/**
 * Third party libraries
 */
window.$      = window.jQuery = require('jquery');
window.Swiper = require('swiper');

const WOW = require('wowjs');

window.wow = new WOW.WOW({
    live: false
});

window.wow.init();


// WEBPACK FOOTER //
// ./resources/assets/js/vendor.js